import React, { useState, useEffect, useContext } from "react"
import { SectionContext } from "../context/sectionContext"
import { PageContext } from "../context/pageContext"
import { JourneyContext } from "../context/journeyContext"
import {
  saveApplication
} from "../../services/apiservice"

const Invest4GFundValue = (props) => {

  const [sectionState, setSectionState] = useContext(SectionContext)
  const [pageState, setPageState] = useContext(PageContext)
  const [journeyState, setJourneyState] = useContext(JourneyContext)

  const handleProceed = () => {
    let sendPayload = {
      applicationData:  journeyState.journeyData,
      journeyData: {
        _id: journeyState.journeyId,
        lastPage: props.currentPageIndex,
        lastSection: props.currentSectionIndex,
        applicationNo: journeyState.applicationNo,
        illustrationNumber: journeyState.illustrationNumber,
        // proposalEntryId: journeyState.proposalEntryId,
        // premium: JSON.parse(biApiData.BIJson)?.[0].TOTAL_5 ,
        lastPageCode: props.pageId,
        planOption: journeyState.planOption,
        lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
      },
    }
    saveApplication(sendPayload).then(res => {
      console.log(res, "application response")
      props.setCurrentSectionIndex(0) // this moves to first section of next page
      props.setCurrentPageIndex(prev => prev + 1) 
    }).catch(err => {
      console.log(err, "err in saveApplication")
    })
  }

  const handlePrevious = () => {
    props.setCurrentSectionIndex(prev => prev- 1)
  }

  return (
    <>
      <style>
        {`
            .mg-ckyc-top.desktop-view-right-side {
                margin-top: 39px;
            }
            @media (max-width: 767px) {
                .mobile-btv {
                padding: 14px 10px !important;
                font-size: 14px;
            }

            .form-group span#plan_option-error {
                top: 49px;
            }
            .form-group span#policy_term-error {
                top: 51px;
            }
            .form-group span#payment_term-error {
                top: 50px;
            }
            .form-group span#payment_frequency-error {
                top: 51px;
            }
            }
            button.select2-selection__clear {
                display: none;
            }
            .form-group {
                position: relative;
            }
            .text-danger {
                color: #a94442;
                position: absolute;
                left: 0;
                bottom: -20px;
            }
            #swords {
                position: absolute;
                z-index: 2;
                right: 38px !important;
                top: 0px;
            }
            #sumAssured-error {
                position: absolute;
                bottom: -3px;
                z-index: 2;
            }
            button.select2-selection__clear {
                display: none;
            }
            .sumassuredselect select#nonfilterselect {
                -webkit-appearance: none;
                -moz-appearance: none;
                background-image: url("images/arrow-sm.png");
                background-repeat: no-repeat;
                background-position-x: 99%;
                background-position-y: 17px;
            }
            #words {
                position: absolute;
                right: 58px;
                top: 27px;
            }
            select::-ms-expand {
                display:none;
            }
            .sumassuredselect {
                position: relative;
                height: 45px;
                width: 100%;
            }
            .sumassuredselect input.form-control {
                position: absolute;
                z-index: 2;
                width: calc(100% - 35px);
                left: 3px;
                height: 42px;
                top: 0;
                box-shadow: none;
                border: 0;
                display: block !important;
                background: #ededed;
                border-right-color: transparent;
            }
            .sumassuredselect select#nonfilterselect {
                position: absolute;
                top: 0;
                width: 100%;
                left: 0;
                right: 0;
                background: #ededed;
                z-index: 1;
                text-align: center;
                border-left-color: transparent;
            }
            @media (min-width: 1024px) and (max-width: 1366px) {
                .top_space{margin-top:11vh;}
            }
            @media (min-width: 992px) and (max-width: 1200px) {
                .fix121{ position:absolute; bottom:0px; width:100%;}
            }

            .jeevan-list{
              display:flex;
              width:100%;
              justify-content: center;
            }
            @media screen and (max-width: 1000px){
              .jeevan-list{
                flex-direction:column;
              }
            }

            .jeevan-neeves-premium{
              display:flex;
              width:100%;
              border:1px solid white;
              padding:1.2rem;
            }

            @media screen and (max-width:1000px){
              .jeevan-neeves-premium{
                flex-direction:column;
              }
            }
            
            .result-design{
            }
            .total-maturity-heading {
              text-align:center;
              position:relative;
              width:100%
            }
            
            .total-maturity-heading::before {
              content:"";
              position:absolute;
              border-top:1px solid white;
              width: 22%;
              left: 5%;
              top: 50%;

            }

            .total-maturity-heading::after {
              content:"";
              position:absolute;
              border-top:1px solid white;
              width: 22%;
              right: 5%;
              top: 50%;
            }

            @media screen and (max-width:1000px){
              .total-maturity-heading::before {
                width: 10%;
                left: 15%;
              }
              .total-maturity-heading::after {
                width: 10%;
                right: 15%;
              }
            }
            

            
            
            .total-maturity-container{
              padding-right:1.2rem;
              width: 100%;
            }
            
            .total-maturity-details{
              list-style:none;
              display:flex;
              margin:0;
              padding:0;
              justify-content:space-between;
              font-size:1.2rem;
              width:100%
              padding-bottom:1rem
            }

            .total-maturity-field{

            }

            .total-maturity-data{

            }
            
            .total-maturity-output{
              border-top:1px solid white;
              font-size:2rem;
              text-align:end;
              padding:1rem 0;
            }
            
            .total-maturity-percentage{
              background:white;
              color:${journeyState.channel === "A" ? "#3e505d" : journeyState.channel === "B" ? "#a20a3a" : journeyState.channel === "C" ? "#0ab0ef" : "#eb7f25"};
              color:var(--lumiq-card-bg);
              padding:.5rem;
              display:flex;
              justify-content:center;
              align-items:center;
            }

          
            .or-jeevan{
              padding-top: 25px;
              margin:1.5rem;
              position:relative;
              height:100%;
            }

            .or-jeevan::before{
              content: " ";
              position: absolute;
              height: 3rem;
              left: 10px;
              top: -13px;
              border: 1px solid white;

            }

            .or-jeevan::after{
              content: " ";
              position: absolute;
              height: 3rem;
              left: 10px;
              bottom: 16px;
              border: 1px solid white;
            }

            @media screen and (max-width:1000px){
              .or-jeevan{
                margin:0;
                position:relative;
                width:100%;
                text-align:center;
              }
              .or-jeevan::before{
                content: " ";
                position: absolute;
                width: 45%;
                top:70%;
                left:0;
                height:1px;
                border: 1px solid white;
              }
              .or-jeevan::after{
                content: " ";
                position: absolute;
                height:1px;
                width: 45%;
                left:initial;
                right:0;
                top:70%;
                border: 1px solid white;
              }
            }
        `}
      </style>

      {/* body Section */}
      <div className="landing-page1-design">
        <div className="container">
          {/* left-side */}
          <div className="col-md-9 pl-pr brd-right mt-20">
            <div className="col-md-12 pl-pr">
              <div className="iselect-box-design mg-bottom-10">
                <div className="heading-design">
                  <div className="iselect-padding left-side-head">
                    <h1 className="iselect-heading"> Your Fund Value </h1>
                  </div>
                </div>

                <div className="iselect-padding">
                  <div className="result-design ">
                    <div className="col-md-12 pl-pr">
                      <div className="col-md-12">
                        <div className="total-maturity-heading">
                          <h2>
                            {" "}
                            Your Fund Values 
                          </h2>
                          <div className="line-jeev"></div>
                        </div>
                      </div>
                      <div className="jeevan-list">

                        <div className="col-md-5 col-xs-12 pl pl-pr wd-total-metrurity">
                          <div className="jeevan-neeves-premium">
                            <div className="listing-total total-maturity-container">
                              <ul className="price-jeevan-toal total-maturity-details">
                                <li className="total-maturity-field" >Project Fund Value (Per Annum)</li>
                                
                              </ul>
                              <div className="total-mrp-jeevan total-maturity-output">
                                {" "}
                                <span className="fa fa-rupee"></span>
                                15,55,000
                              </div>
                            </div>
                            <div className="percnt-jeevan total-maturity-percentage">8%</div>
                          </div>
                        </div>
                        <div>
                          <div className="or-jeevan">
                            <p>OR</p>
                          </div>
                        </div>
                        <div className="col-md-5 col-xs-12 pr pl-pr wd-total-metrurity">
                          <div className="jeevan-neeves-premium">
                            <div className="listing-total total-maturity-container">
                              <ul className="price-jeevan-toal total-maturity-details">
                                <li className="total-maturity-field" >Project Fund Value (Per Annum)</li>
                                
                              </ul>
                              <div className="total-mrp-jeevan total-maturity-output">
                                {" "}
                                <span className="fa fa-rupee"></span>
                                12,60,000
                              </div>
                            </div>
                            <div className="percnt-jeevan total-maturity-percentage">4%</div>
                          </div>
                        </div>
                        </div>
                      </div>

                  </div>
                  <div className="iselect-mg-bottom hidden-desktop-screen mt-30">
                    <div className="col-md-12">
                      <div className="but-center text-right">
                        <div className="submit-btn cen">
                          {" "}
                          <a aria-hidden="true" onClick={handlePrevious}>Previous</a>{" "}
                        </div>
                        <a aria-hidden="true" onClick={handleProceed}>
                          <input
                            className="previous-btn cen"
                            style={{
                              color: "white",
                              padding: "14px 40px",
                              border: "none",
                            }}
                            type="submit"
                            value="View BI To Proceed"
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* left-side */}
          {/* right-side */}
            <div className="col-md-3 right-box-design-size mg-ckyc-top desktop-view-right-side">
                <div className="progrss-board">
                    <ul className="nav nav-tabs progrss-board-tabs">
                        <li rel-index="0" className="active"> <a className="btn" aria-controls="step-1" role="tab" data-toggle="tab"> <span className="fa fa-angle-right"></span>
                        <p>Personal Details </p>
                        </a>
                        <div className="liner active"></div>
                        </li>
                        <li rel-index="1"  className="active"> <a className="btn disabled" aria-controls="step-2" role="tab" data-toggle="tab"><span className="fa fa-angle-right"></span>
                        <p>Investment Details </p>
                        </a>
                        <div className="liner active"></div>
                        </li>
                        <li rel-index="1"  className="active"> <a className="btn disabled" aria-controls="step-2" role="tab" data-toggle="tab"><span className="fa fa-angle-right"></span>
                        <p>Portfolio Management Options</p>
                        </a>
                        <div className="liner active"></div>
                        </li>
                        <li rel-index="2" className="active"> <a className="btn disabled" aria-controls="step-3" role="tab" data-toggle="tab"><span className="fa fa-angle-right"></span>
                        <p>Your Fund Value </p>
                        </a> </li>
                    </ul>
                </div>
            </div>
          {/* right-side */}
        </div>
      </div>

      {/* body Section */}

      {/* mobile view button */}
      <div className="mobile-view-btn-Q1">
        <div className="iselect-mg-bottom">
          <div className="col-md-12">
            <div className="but-center text-center">
              <div className="submit-btn cen">
                {" "}
                <a aria-hidden="true" onClick={handlePrevious}>Previous</a>{" "}
              </div>
              <a aria-hidden="true" onClick={handleProceed}>
                <input
                  className="previous-btn cen mobile-btv"
                  style={{
                    color: "white",
                    padding: "14px 40px",
                    border: "none",
                  }}
                  type="submit"
                  value="View BI To Proceed"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
      {/* mobile view button */}
    </>
  )
}

export default Invest4GFundValue
